import React from 'react'
import {
  ContractPageBranding,
  hasBrandingHeaderContent,
} from '../utils/contractPageBranding'

type Props = {
  branding?: ContractPageBranding | null
  className?: string
}

export function ContractPageBrandingBar({ branding, className }: Props) {
  if (!hasBrandingHeaderContent(branding)) {
    return null
  }

  return (
    <div className={['contract-page-branding-bar', className].filter(Boolean).join(' ')}>
      {branding?.logo && (
        <img
          src={branding.logo}
          alt=""
          className="contract-page-branding-bar__logo"
        />
      )}
      {branding?.title && (
        <div className="contract-page-branding-bar__title">{branding.title}</div>
      )}
    </div>
  )
}
